import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { SidebarButtonConfig } from './sidebar.model';
import { SidebarService } from './sidebar.service';

@Component({
  selector: 'ui-sidebar',
  standalone: true,
  imports: [ButtonModule, RippleModule, MenuModule, RouterLink],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  private readonly sidebarService = inject(SidebarService);

  public readonly isLogoutLoading = input(false);

  public readonly sidebarClosed = output<void>();
  public readonly logoutClicked = output<void>();

  protected readonly isSidebarOpen = this.sidebarService.isSidebarOpen;

  protected readonly sidebarButtonConfig: SidebarButtonConfig[] = [
    {
      label: 'Map',
      iconName: 'pi pi-map',
      routerLink: 'map',
    },
    {
      label: 'Orders',
      iconName: 'pi pi-folder-open',
      routerLink: 'orders',
      queryParams: {
        type: 'open',
      },
    },
    {
      label: 'Vehicles',
      iconName: 'pi pi-truck',
      routerLink: 'vehicles',
      queryParams: {
        type: 'truck',
      },
    },
    {
      label: 'Drivers',
      iconName: 'pi pi-users',
      routerLink: 'drivers',
    },
    {
      label: 'Firm',
      iconName: 'pi pi-building',
      routerLink: 'firm',
    },
  ];
}
